import React, { useState } from 'react'
import { Col, Form, Row, Upload, Button } from 'antd'
import { File as FileType, Photo } from 'types/globalTypes'
import Icon from 'assets/Images/icon.svg'
import './styles/styles.scss'
import Coverimage from 'assets/Images/Coverimage.svg'
import { useFileUploadMutation } from 'api/FileUpload/FileUpload'
import ButtonSpinner from './ButtonSpinner'
import { VideoCameraOutlined, CloseOutlined } from '@ant-design/icons'

interface VideoUploadProps {
  videoIds: string[]
  setVideoIds: React.Dispatch<React.SetStateAction<string[]>>
  fileData?: FileType
  loading?: boolean
  docType?: 'video/*'
  files?: FileType[] | Photo[]
  multiple?: boolean
  component?: string
  sourceType?:
  | 'guardian_profile'
  | 'user_profile'
  | 'organization_profile'
  | 'mentor_profile'
  | 'organizer_profile'
  | 'authorized_adult_profile'
  | 'kid_profile'
  | 'amenity'
  | 'live_update'
  | 'other'
  | 'icon'
}

const VideoUpload: React.FC<VideoUploadProps> = ({
  videoIds,
  setVideoIds,
  component,
  fileData,
  loading,
  docType,
  files,
  multiple,
  sourceType,
}) => {
  const [videoPreviewUrls, setVideoPreviewUrls] = useState<any[]>(
    files ? files.map((file: any) => file.link) : [],
  )
  const [uploading, setUploading] = useState(false)

  const { mutate: fileUploadMutation } = useFileUploadMutation()

  const propsForVideo = {
    showUploadList: false,
    className: 'mt-100',
    accept: docType || 'video/*',
    multiple: multiple || false,

    customRequest: ({ file }: any) => {
      // Prevent default upload behavior and handle manually
      const fileObj = new FormData()
      fileObj.append('file', file)
      let newFile = {
        title: file.name || 'video',
        description: 'intro media video',
        altText: 'video',
        sourceType: sourceType || 'organizer_profile',
      }

      setUploading(true)

      fileUploadMutation(
        { payload: fileObj, newFile },
        {
          onSuccess: (fileSuccessData: any) => {
            setVideoPreviewUrls(prev => [
              ...prev,
              fileSuccessData.uploadResult.link,
            ])
            setVideoIds(prev => [...prev, fileSuccessData.id])
            setUploading(false)
          },
          onError: (error: any) => {
            setUploading(false)
          },
        },
      )
    },
  }
  const handleDeleteVideo = (idx: number) => {
    const newVideoData = videoPreviewUrls.filter(
      (_: any, index: number) => index !== idx,
    )
    const newVideoIds = videoIds.filter(
      (_: any, index: number) => index !== idx,
    )
    setVideoPreviewUrls(newVideoData)
    setVideoIds(newVideoIds)
  }

  const uploadButton =
    component === 'News' ? (
      uploading ? (
        <ButtonSpinner size={16} color="#2ba7ca" />
      ) : (
        <>
          <Button
            icon={<VideoCameraOutlined />}
            className="media-button"
          >
            Video
          </Button>
        </>
      )
    ) : (
      <div className="video-upload-container">
        {uploading ? (
          <ButtonSpinner size={16} color="#2ba7ca" />
        ) : (
          <div className="upload-acover-pic">
            <img src={Coverimage} alt="avatar" />
            <span>Upload video</span>
          </div>
        )}
      </div>
    )

  return (
    <>
      {component === 'News' ? (
        <Upload
          {...propsForVideo}
          showUploadList={false}
          multiple={multiple || false}
          disabled={!multiple && videoPreviewUrls.length > 0}
          className="media-button"
        >
          {uploadButton}
        </Upload>
      ) : (
        <Row gutter={10}>
          <Col>
            <Form.Item name="videoIds">
              <Row>
                <Col className="d-flex cvcv">
                  <Upload
                    {...propsForVideo}
                    listType="picture-card"
                    multiple={multiple || false}
                    disabled={!multiple && videoPreviewUrls.length > 0}
                    className="cover-img-step-5"
                  >
                    {uploadButton}
                  </Upload>
                </Col>
              </Row>
            </Form.Item>
          </Col>

          <Col>
            {videoPreviewUrls.length > 0 && (
              <Col className="antd-img-upload flex scroller gap-20 pb-10px">
                {videoPreviewUrls.map((item: any, index: number) => {
                  return (
                    <div className="img-preview" key={index}>
                      <img
                        alt="#delete"
                        className="closing-icon"
                        src={Icon}
                        onClick={() => handleDeleteVideo(index)}
                      />
                      <div className="video-preview">
                        <video
                          key={index}
                          className="br-12"
                          height={100}
                          width={100}
                          controls
                          preload="metadata"
                        >
                          <source src={item.link || item.url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                        <div className="video-info">
                          <p className="video-name">{item.name}</p>
                          {item.size && (
                            <p className="video-size">
                              {(item.size / (1024 * 1024)).toFixed(1)} MB
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </Col>
            )}
          </Col>
        </Row>
      )}
    </>
  )
}

export default VideoUpload
